import React from 'react';
import { Card, CardContent, Skeleton, Box, Typography, Chip } from '@mui/material';

interface StoreCardSkeletonProps {
    icon?: React.ReactNode;
    title?: string;
    rows?: number;
    hasAction?: boolean;
    hasChips?: boolean;
}

const StoreCardSkeleton = ({ 
    icon, 
    title, 
    rows = 4,
    hasAction = false,
    hasChips = false
}: StoreCardSkeletonProps) => {
    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {icon && <Box sx={{ color: '#556ee6', display: 'flex' }}>{icon}</Box>}
                        {title ? (
                            <Typography variant="h6">{title}</Typography>
                        ) : (
                            <Skeleton variant="text" width={200} height={28} />
                        )}
                    </Box>
                    {hasAction && <Skeleton variant="rectangular" width={70} height={30} sx={{ borderRadius: 1 }} />}
                </Box>
                
                <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                        {Array.from({ length: rows }).map((_, index) => (
                            <tr key={index}>
                                <td style={{ padding: '8px 0', verticalAlign: 'top', width: hasChips ? '50%' : '40%' }}>
                                    <Skeleton variant="text" width="80%" height={20} />
                                </td>
                                <td style={{ padding: '8px 0', paddingLeft: '16px' }}>
                                    {hasChips && index % 2 === 0 ? (
                                        <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '12px' }} />
                                    ) : (
                                        <Skeleton variant="text" width="60%" height={20} />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Box>
            </CardContent>
        </Card>
    );
};

export default StoreCardSkeleton;
